import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import {
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-confirm-session-expired-dialog',
  templateUrl: './confirm-dialog.component.html',
  standalone: true,
  imports: [ButtonModule, TranslateModule, DynamicDialogModule],
})
export class ConfirmDialogComponent implements OnInit {
  flag: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {
    this.flag = this.config.data.flag;
  }

  ngOnInit(): void {}

  Close(bol: boolean) {
    this.ref.close(bol);
  }
}
